import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M9.4 12A5.6 5.6 0 0 1 15 6.4h2a5.6 5.6 0 1 1 0 11.2h-.5a.6.6 0 0 1 0-1.2h.5a4.4 4.4 0 1 0 0-8.8h-2a4.4 4.4 0 0 0-4.4 4.4.6.6 0 1 1-1.2 0ZM7 7.6a4.4 4.4 0 0 0 0 8.8h2a4.4 4.4 0 0 0 4.4-4.4.6.6 0 0 1 1.2 0A5.6 5.6 0 0 1 9 17.6H7A5.6 5.6 0 1 1 7 6.4h.5a.6.6 0 1 1 0 1.2H7Z"
      clip-rule="evenodd"
    />
  </svg>
`;
